export default __webpack_public_path__ + "static/media/laptop2.59a6ad4c.jpeg";